import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ZonarUIMaterialModule } from '@zonar-ui/material';
import { ZonarUiIconModule } from '@zonar-ui/icon';

@NgModule({
  imports: [ZonarUIMaterialModule, ZonarUiIconModule, CommonModule]
})
export class DriverModule {}
